import React from 'react';
import PropTypes from 'prop-types';
import { Spacer, Visible } from '@tfecom-thermofisher/react-komodo-design';

import DeleteImg from 'src/assets/images/icon-delete.svg';
import { Button, Message } from 'src/core/components';
import { Email } from 'src/models';
import messages from 'src/components/OligoDNA/messages';

const EmailsListComponent = ({
  emails,
  handleDeleteEmail,
  onSubmit,
}) => (
  <>
    <Visible when={emails?.length > Email.MAX_LENGTH - 1}>
      <Spacer top={10} />
    </Visible>
    <Visible when={emails?.length}>
      <b>
        <Message message={messages.emailsList} />
      </b>

      <Spacer top={10} />

      <div className="email-list">
        {emails?.map((item) => (
          <div
            className="flex-row justify-space-between email-list-item"
            key={item.value}
          >
            <span>{item.value}</span>
            <div
              className="cursor-pointer"
              onClick={() => handleDeleteEmail(item)}
            >
              <img src={DeleteImg} alt="" />
            </div>
          </div>
        ))}
      </div>
    </Visible>

    <Spacer top={20} />
    <div>
      <Button
        type="primary"
        onClick={onSubmit}
        label={messages.shareOrder}
        disabled={!emails?.length}
      />
    </div>
  </>
);

EmailsListComponent.propTypes = {
  emails: PropTypes.array,
  handleDeleteEmail: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default EmailsListComponent;
